/* global rp$, window */
import './tabbed_links.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Tabbed Links Module
	 * -----------------------------------------
	 * @section tabbed_links
	 ********************************************/
	(function TabbedLinksModule() {
		$onReady({
			rp$, window,
			label: 'tabbed_links',
			fn: function () {

				const $tabbedLinksModules = rp$('.tabbed-links-module');

				rp$.each($tabbedLinksModules, function TabbedLinks_Iterator(idx, tabbedLinksModuleEle) {
					const $tabbedLinksModule = rp$(tabbedLinksModuleEle);
					const $nav = $tabbedLinksModule.find('.nav-items');
					const $navItems = $nav.find('.nav-item');
					const $tabs = $tabbedLinksModule.find('.tabs');
					const $tabElems = $tabs.find('.tab');

					let currentTabIndex;

					function setTab(index) {
						if (currentTabIndex > -1) {
							$navItems.eq(currentTabIndex).removeClass('active');
							$tabElems.eq(currentTabIndex).removeClass('active');
						}

						$navItems.eq(index).addClass('active');
						$tabElems.eq(index).addClass('active');
						currentTabIndex = index;

						handleSlideBar(index);
					}

					rp$.each($navItems, function (idx, navItem) {
						const $navItem = rp$(navItem);
						$navItem.on('click', function() {
							setTab(idx);
						});
					});

					// Navigation Slide Bar
					const $slideRail = $tabbedLinksModule.find('.slide-rail');
					const $slideBar = $slideRail.find('.slide-bar');
					const handleSlideBar = index => {

						// Bar Width
						const $tab = $navItems.eq(index);
						const $tabWidth = $tab.width();

						// Bar Position
						let tabLengths = 0;
						for (let i = 0; i < index; i++) {
							const $tabBeforeIndex = $navItems.eq(i);
							let $tabBeforeIndexWidth = $tabBeforeIndex.outerWidth(true);
							if (i === 0) {
								const tabPaddingRight = $tabBeforeIndex.css('padding-right');
								$tabBeforeIndexWidth += parseInt(tabPaddingRight);
							}
							tabLengths += $tabBeforeIndexWidth;
						}

						$slideBar.css('left', tabLengths);
						$slideBar.width($tabWidth);
					};

					setTab(0);
					window.addEventListener('resize', setTab(currentTabIndex));
				});
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}